﻿export const REDUCE_BRANDING = 'REDUCE_BRANDING';
export const GET_BRANDING = 'GET_BRANDING';

export const REDUCE_GENERAL = 'REDUCE_GENERAL';
export const GET_GENERAL = 'GET_GENERAL';

export const UPDATE_BRANDING = 'UPDATE_BRANDING';
